import { Module } from "vuex";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { RootState } from "@/store/types";
import { Log, LogState } from "@/services/logging/types";
import { actions } from "./actions";

export const state = {
    logs: [] as Log[],
    logLevels: ""
} as LogState;

const namespaced: boolean = true;

export const logger: Module<LogState, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations
};
